import { CustomerFragment } from '../../__gql-codegen-types/pim/graphql';
import { CRYSTALLIZE_CUSTOMER_META_NUKI_CLUB_KEY } from '../../types/constants';
import { NukiClubMeta } from '../../types/NukiClubMeta';

export function parseCustomerMetaNukiClub(
  customerMeta: CustomerFragment['meta'],
): NukiClubMeta | undefined {
  const rawMeta = customerMeta?.find(
    (meta) => meta.key === CRYSTALLIZE_CUSTOMER_META_NUKI_CLUB_KEY,
  )?.value;
  if (!rawMeta) {
    return undefined;
  }
  return JSON.parse(rawMeta) as NukiClubMeta;
}
